import React from "react";
import Badge from "components/common/Badge";
import "./noticeItem.scss";

// 예약·커뮤니티 알림과 동일한 상대시각 포맷 (7일 경과 시 "M월 D일")
const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return "";
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMinutes < 1) return "방금 전";
    if (diffInMinutes < 60) return `${diffInMinutes}분 전`;
    if (diffInHours < 24) return `${diffInHours}시간 전`;
    if (diffInDays < 7) return `${diffInDays}일 전`;

    return date.toLocaleDateString("ko-KR", {
        month: "long",
        day: "numeric",
    });
};

/**
 * 공지사항 목록 행
 * @param {object} notice - { id, title, is_important, published_at }
 * @param {function} onClick - 행 클릭 핸들러
 */
const NoticeItem = ({ notice, onClick }) => {
    const { title, is_important, published_at } = notice;

    return (
        <div className="notice-item" onClick={() => onClick?.(notice)}>
            <div className="notice-item__main">
                {is_important && (
                    <Badge text="중요" type="soft" color="red" />
                )}
                <p className="notice-item__title">{title}</p>
            </div>
            <span className="notice-item__date">{formatTime(published_at)}</span>
        </div>
    );
};

export default NoticeItem;
